import React, { ReactNode, useReducer } from "react";

import { initialState, reducer, StoreContext } from "../../../store";
import { DispatchContext } from "../../../store/dispatch-context";

interface IStoreProviderProps {
  children: ReactNode;
}

export const StoreProvider = ({ children }: IStoreProviderProps): JSX.Element => {
  const [state, dispatch] = useReducer(reducer.useHandler, initialState);

  return (
    <StoreContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
    </StoreContext.Provider>
  );
};

StoreProvider.displayName = "StoreProvider";
